"use client";
import React, { useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { usePathname } from "next/navigation";
import { Container } from "react-bootstrap";
import { fetchSimilarCategories } from "@/redux/categoriesSlice";
import CategorySlider from "@/components/common-components/CategorySlider";

const ORG_KEY = process.env.NEXT_PUBLIC_ORGANIZATION_KEY;

export default function SubCategory({
  categoryDetails,
  marketArea,
  isSubCategory = false,
}) {
  const dispatch = useDispatch();

  // Select specific state slices to minimize re-renders
  const similarCategory = useSelector((state) => state.categories.similarCategory);
  const status = useSelector((state) => state.categories.status);

  const currentPath = usePathname();

  // Extract IDs to ensuring stable dependencies
  const categoryId = categoryDetails?.id;
  const parentCategoryId = categoryDetails?.parent_category_id;

  // Path Analysis
  const pathParts = useMemo(() => currentPath.split("/").filter(Boolean), [currentPath]);
  const activeMarketArea = useMemo(() => {
    return pathParts.includes(marketArea?.slug) ? pathParts[0] : null;
  }, [pathParts, marketArea]);

  useEffect(() => {
    if (isSubCategory && parentCategoryId && categoryId) {
      dispatch(
        fetchSimilarCategories({
          organizationId: ORG_KEY,
          categoryId: parentCategoryId,
          subCategoryId: categoryId,
        })
      );
    } else if (!isSubCategory && categoryId) {
      dispatch(
        fetchSimilarCategories({
          organizationId: ORG_KEY,
          categoryId: categoryId,
        })
      );
    }
  }, [dispatch, isSubCategory, categoryId, parentCategoryId]);

  const generateCategoryPath = (categorySlug) => {
    return activeMarketArea
      ? `${activeMarketArea}/${categorySlug}-in-${activeMarketArea}`
      : `${categorySlug}-in-${marketArea?.slug}`;
  };

  const dataToMap = useMemo(() => {
    if (isSubCategory && categoryDetails) return similarCategory?.data?.data || [];
    if (!isSubCategory && categoryDetails) return similarCategory?.data?.sub_data || [];
    return [];
  }, [categoryDetails, isSubCategory, similarCategory]);

  if (status === "failed") return null;
  if (!dataToMap?.length) return null;

  const titleNormal = !isSubCategory && categoryDetails ? "Explore More Types Of " : "Explore More ";
  const titleHighLight = !isSubCategory && categoryDetails ? categoryDetails?.category_name : "Services";
  const description = categoryDetails
    ? `Delve into a variety of ${categoryDetails?.category_name} treatments, crafted to enhance every smile and suit your individual needs.`
    : `Discover a comprehensive range of dental services tailored to your unique oral health and cosmetic preferences.`;

  return (
    <section
      data-aos="fade"
      // style={{backgroundColor:!isSubCategory && categoryDetails ? "var(--bg-secondary)" : ""}}
      className="mb-0"
    >
      <Container>
        <h2 className="fw-semibold text-center section-title mb-3">
          {titleNormal} <span>{titleHighLight}</span>
        </h2>
        <p style={{ maxWidth: "635px" }} className="mx-auto text-muted text-center mb-5">
          {description}
        </p>

        <CategorySlider
          dataToMap={dataToMap}
          marketArea={marketArea}
          generateCategoryPath={generateCategoryPath}
        />
      </Container>
    </section>
  );
}
